/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const AgenceType = new ObjectType({
    name: 'AgenceItem',
    description: 'Cet objet represente la page agence',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id de la page',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug de la page',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre de la page',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content de la page',
            resolve: (root) => root.content.rendered
        },
        equipe: {
            type: StringType,
            description: 'La section équipe de la page',
            resolve: (root) => root.acf.section_equipe
        },
        fondement: {
            type: StringType,
            description: 'La section fondement de la page',
            resolve: (root) => root.acf.section_fondement
        },
        partenaire: {
            type: StringType,
            description: 'La section fondement de la page',
            resolve: (root) => root.acf.section_partenaire_temoignage
        },
    }),
});

export default AgenceType;



// WEBPACK FOOTER //
// ./data/types/AgenceType.js